const servicesData = [
    {
        id: 'industrial-structures',
        icon: <i className="fa-regular fa-industry" style={{ color: "#333333" }}></i>,
        title: 'Endüstriyel Yapılar',
        description: 'Fabrika ve üretim tesisleri için anahtar teslim inşaat çözümleri sunuyoruz.',
    },
    {
        id: 'commercial-structures',
        icon: <i className="fa-regular fa-building" style={{ color: "#333333" }}></i>,
        title: 'Ticari Yapılar',
        description: 'Showroom ve ticari alanların tasarım ve inşasını gerçekleştiriyoruz.',
    },
    {
        id: 'office-buildings',
        icon: <i className="fa-regular fa-briefcase" style={{ color: "#333333" }}></i>,
        title: 'İdari ve Ofis Binaları',
        description: 'Modern ve fonksiyonel çalışma alanları inşa ediyoruz.',
    },
    {
        id: 'residential-projects',
        icon: <i className="fa-regular fa-house" style={{ color: "#333333" }}></i>,
        title: 'Konut Projeleri',
        description: 'Güvenli ve modern yaşam alanları inşa ediyoruz.',
    },
    {
        id: 'infrastructure-works',
        icon: <i className="fa-regular fa-road" style={{ color: "#333333" }}></i>,
        title: 'Altyapı ve Çevre Düzenleme',
        description: 'Altyapı ve saha düzenleme çözümleri sunuyoruz.',
    },
    {
        id: 'project-management',
        icon: <i className="fa-regular fa-diagram-project" style={{ color: "#333333" }}></i>,
        title: 'Proje Yönetimi',
        description: 'Planlamadan teslimata tüm süreci yönetiyoruz.',
    },

    // NEW SERVICES

    {
        id: 'school-projects',
        icon: <i className="fa-regular fa-school" style={{ color: "#333333" }}></i>,
        title: 'Okullar',
        description: 'Eğitim yapıları için modern ve güvenli okul binaları inşa ediyoruz.',
    },
    {
        id: 'production-facilities',
        icon: <i className="fa-regular fa-gears" style={{ color: "#333333" }}></i>,
        title: 'Üretim Tesisleri',
        description: 'Sanayi ve üretim tesisleri için yüksek standartlı çözümler sunuyoruz.',
    },
    {
        id: 'warehouse-areas',
        icon: <i className="fa-regular fa-warehouse" style={{ color: "#333333" }}></i>,
        title: 'Depo Alanları',
        description: 'Lojistik ve depolama için fonksiyonel yapı çözümleri geliştiriyoruz.',
    },
    {
        id: 'car-showroom-buildings',
        icon: <i className="fa-regular fa-car" style={{ color: "#333333" }}></i>,
        title: 'Araç Showroom Binaları',
        description: 'Otomotiv sektörüne özel modern showroom yapıları tasarlıyoruz.',
    },
    {
        id: 'social-facilities',
        icon: <i className="fa-regular fa-people-roof" style={{ color: "#333333" }}></i>,
        title: 'Sosyal Tesisler',
        description: 'Toplumsal kullanım alanları için estetik ve işlevsel tesisler inşa ediyoruz.',
    },
];

export default servicesData;